import React, {useState} from 'react';
import { Row, Col, Button, Card, CardBody, } from 'reactstrap';
import { useSelector  } from 'react-redux';

import Loader from '~/components/Loader/Loader';
import TainingNewModal from '../Training/new/TrainingNewModal';

// import { Container } from './styles';

const trainingTMP = {
    name: "Consistencia",
    internal_name: "consistencia",
    description: "treino para ganho de consistencia",
    activity_type: "DURATION",
    clone_type: "SCHEMA",
    duration: 30,
    distance: null,
    pace: null,
    calorie: null,
    altimetry: 200,
    exec_duration: 40,
    exec_distance: null,
    exec_pace: null,
    exec_calorie: null,
    exec_altimetry: 200,
    folder_id: 3,
    training_category_id: 1,
    trainingGroups: [
      {
          name: "Crescente",
          description: "treino crescente de inicio",
          activity_type: "DISTANCE",
          clone_type: "SCHEMA",
          duration_total: null,
          distance_total: 5,
          zone: "ZONE2",
          repetition: 5,
          trainingActivities: [
            {
              name: "Acelerando",
              internal_name: "treino crescente",
              activity_type: "DISTANCE",
              clone_type: "TEMPLATE",
              duration: null,
              distance: 0.8,
              zone: "ZONE5"
            },
            {
                name: "Acelerando",
                internal_name: "treino crescente",
                activity_type: "DISTANCE",
                clone_type: "TEMPLATE",
                duration: null,
                distance: 0.6,
                zone: "ZONE1"
              }
          ]
      },
    ]
  };

export default function Calendar() {

  const loading = useSelector(state => state.auth.loading);
  const [training, setTraining] = useState({trainingGroups: []});
  const [show, setShow] = useState(false);

  // api.get('users')


  function handleModal() {
    setShow(!show);
  }

  return (
    <React.Fragment>
            { /* preloader */}
            {loading && <Loader />}

            <Row>
                <Col>
                    <div className="page-title-box">
                        <Row>
                            <Col lg={7}>
                                <h4 className="page-title">Treinos</h4>
                            </Col>
                            <Col lg={5} className="mt-lg-3 mt-md-0">
                                
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col lg={12}>
                    <Card className="shadow">
                        <CardBody>
                            
                            <Button color="info" onClick={handleModal}>Cadastrar Treino</Button>

                            {show && <TainingNewModal open={show} training={training} toggle={handleModal} /> }

                        </CardBody>
                    </Card>
                </Col>
            </Row>
    </React.Fragment>
  );
}
